import { useMemo } from 'react';
import { type FieldPath, type FieldValues } from 'react-hook-form';

import RichTextEditor from '@@form/components/RichTextEditor/RichTextEditor';
import { createHasLoadingElement } from '@@form/utils/validators/hasLoadingElement';

import RichTextField, { type RichTextFieldProps } from './RichTextField';

export const RichTextEditorField = <
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
    props: RichTextFieldProps<TFieldValues, TName>,
) => {
    const { inputProps, ...rest } = props;
    const editorId = useMemo(() => crypto.randomUUID(), []);
    const hasLoadingElement = useMemo(() => createHasLoadingElement(editorId), [editorId]);

    return (
        <RichTextField
            {...rest}
            component={RichTextEditor}
            inputProps={{
                ...inputProps,
                editorId,
            }}
            validate={[hasLoadingElement]}
        />
    );
};

export default RichTextEditorField;
